import React from 'react';
import { IconProps } from '.';
import { Config } from '../../helpers/config';

export type StarIconProps = IconProps & {
  isFilled?: boolean;
  color?: string;
};

export const StarIcon: React.FC<StarIconProps> = ({
  isFilled = false,
  width = '16',
  height = '15',
  color = Config.primaryBlue,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 15"
    >
      <path
        fill={isFilled ? color : undefined}
        stroke={color}
        strokeWidth="0.477"
        d="M7.71.83a.362.362 0 01.688 0l1.327 4.085c.112.345.434.58.797.58h4.296c.35 0 .496.448.212.654l-3.475 2.524a.838.838 0 00-.304.938l1.327 4.085a.362.362 0 01-.557.404l-3.475-2.525a.838.838 0 00-.985 0L4.086 14.1a.362.362 0 01-.557-.404L4.857 9.61a.838.838 0 00-.305-.938L1.077 6.15a.362.362 0 01.213-.655h4.295a.838.838 0 00.797-.579L7.71.83z"
      ></path>
    </svg>
  );
};
